import React from 'react';

/** What the delivery-day bars' colours mean. */
const DeliveryLegend: React.FC<{ className?: string }> = ({ className = '' }) => (
  <p className={`flex items-center gap-4 text-xs text-ink-subtle ${className}`}>
    <span className="flex items-center gap-1.5">
      <span aria-hidden="true" className="inline-block h-3 w-3 rounded-[2px] bg-ok" />
      Delivered
    </span>
    <span className="flex items-center gap-1.5">
      <span aria-hidden="true" className="inline-block h-3 w-3 rounded-[2px] bg-paper-300" />
      Not delivered
    </span>
  </p>
);

export default DeliveryLegend;
